import React, { useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import BInput from './BInput'; // Adjust path if necessary

const BPassword = ({
  label = 'Mot de passe',
  name = 'password',
  placeholder = 'Entrez votre mot de passe',
  isDirty = false,
  isHidden = false,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => setVisible(!visible);

  const VisibilityIcon = visible ? IconEyeOff : IconEye;
  const inputType = visible ? 'text' : 'password';

  return (
    <BInput
      type={inputType}
      label={label}
      name={name}
      placeholder={placeholder}
      isDirty={isDirty}
      isHidden={isHidden}
      icon={props.icon}
      {...props}
    >
      <button
        type="button"
        onClick={toggleVisibility}
        className="absolute inset-y-0 end-0 flex items-center pe-3 text-slate-500 hover:text-slate-700"
        tabIndex={-1}
      >
        <VisibilityIcon className="size-4" />
      </button>
    </BInput>
  );
};

export default BPassword;
